import { render, staticRenderFns } from "./PersonsView.vue?vue&type=template&id=427b0c57&scoped=true"
import script from "./PersonsView.vue?vue&type=script&lang=js"
export * from "./PersonsView.vue?vue&type=script&lang=js"
import style0 from "./PersonsView.vue?vue&type=style&index=0&id=427b0c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b0c57",
  null
  
)

export default component.exports